import { EditableText, defineBlock } from "eddev/blocks"
import { useHydrating } from "eddev/routing"
import { usePublications } from "@hooks/queries"
import { Col, Grid } from "@components/layout/Grid"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { useMemo } from "react"
import { Button } from "@components/atoms/Button"
import { ButtonList } from "@components/atoms/ButtonList"
import { ContainerReset } from "@components/layout/GridReset"

export const meta: BlockMeta = {
  title: "Publications group",
  category: "common",
  icon: "align-center",
  keywords: ["filter"],
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
    multiple: false,
  },
}

export default defineBlock("publications/publications-group", (props) => {
  const publications = usePublications()
  const hydrating = useHydrating()
  const publicationList = useMemo(() => {
    if (publications.data?.documentPublications?.nodes) {
      return publications.data.documentPublications.nodes.filter((node) => node.documents!.nodes.length > 0)
    }
    return []
  }, [publications])

  return (
    <ContainerReset>
      <Grid className="bg-light-grey rounded-md my-7 overflow-hidden [&_h2]:type-title-xl lg:justify-between wp:lg:w-full">
        <Col initial={12} tablet={6} laptop={7} className="order-1 md:order-2">
          <ResponsiveImage {...props.heroImage} aspect={696 / 392} />
        </Col>
        <Col initial={12} tablet={6} laptop={5} className="order-2 md:order-1 md:flex md:flex-col">
          <div className="flex flex-col justify-between p-5 w-full grow md:pt-6 md:pr-0 md:pb-6 md:pl-7">
            <EditableText as="h2" store="title" placeholder="Title" />

            <ButtonList>
              {!hydrating && publicationList.map((publication, i) => (
                <Button color="grey" size="small" icon="ARROW_RIGHT" iconStyle="right" href={publication.uri!} key={i}>
                  {publication.name}
                </Button>
              ))}
            </ButtonList>
          </div>
        </Col>
      </Grid>
    </ContainerReset>
  )
})
